import {
  FETCH_PAYMENTS,
  FETCH_PAYMENTS_SUCCESS,
  SHOW_PAYMENTS_LOADER,
  SHOW_PAYMENTS_MESSAGE,
  HIDE_PAYMENTS_MESSAGE
} from 'constants/ActionTypes';


export const fetchPayments = (from, to, page, limit, lastEvaluatedKey) => {
  return {
    type: FETCH_PAYMENTS,
    payload: { from, to, page, limit, lastEvaluatedKey }
  };
};
export const fetchPaymentsSuccess = (data) => {
  return {
    type: FETCH_PAYMENTS_SUCCESS,
    payload: data
  }
};
export const showPaymentsLoader = (data) => {
  return {
    type: SHOW_PAYMENTS_LOADER,
    payload: data
  }
};
export const showPaymentsMessage = (message, messageStatus = false) => {
  return {
    type: SHOW_PAYMENTS_MESSAGE,
    payload: { message, messageStatus }
  };
};
export const hidePaymentsMessage = () => {
  return {
    type: HIDE_PAYMENTS_MESSAGE
  };
};




// WEBPACK FOOTER //
// ./actions/Payments.js